import {useCallback, useEffect} from 'react';
import {useDispatch, useSelector, shallowEqual} from 'react-redux';
import {
    useRouteMatch, useParams
} from 'react-router-dom';

import {useList} from 'react-use';

import {getCategoryTopics, createTopic, updateTopic, ACTIONS} from '../actions/user-topic';
import {saveTopicToGame} from '../actions/my-topic';

export default function useTabTopics(type, listMenu) {
    const { url } = useRouteMatch();
    const {id, teamId} = useParams();
    const dispatch = useDispatch();

    const [menus, menuHelper] = useList(listMenu);

    const tabMenu = useSelector((state) => state.userTopic.tabMenu, shallowEqual);

    useEffect(() => {
        fetchCategoryTopics()
    }, [id]);

    useEffect(() => {
        updateMenu();
    }, [tabMenu]);

    const updateMenu = useCallback(() => {
        const list = menus.filter((item) => !item.dynamic);
        tabMenu.forEach((item) => {
            list.push({
                name: item.title || '', to: `${url}/topic/${item.id}`, exact: false, dynamic: true, id: item.id
            });
        });
        menuHelper.set(list);
    }, [tabMenu, menus]);

    const fetchCategoryTopics = useCallback(() => {
        dispatch(getCategoryTopics(type, id));
    }, [id]);

    const onCreateTopic = useCallback(async (useDefault) => {
        const params = {useDefault};
        if(type === 'team') {
            params.teamId = id;
        }
        if(type === 'player') {
            params.playerId = id;
        }
        if(type === 'game') {
            params.gameId = id;
            params.teamId = teamId;
        }
        const response = await dispatch(createTopic(params));
        menuHelper.push({
            name: response.title || '', to: `${url}/topic/${response.id}`, exact: false, dynamic: true, id: response.id
        });
    }, [id]);

    const onCreateExistTopic = useCallback(async(gameId, params) => {
        if(type === 'game') {
            const response = await dispatch(saveTopicToGame(gameId, params));
            menuHelper.push({
                name: response.title || '', to: `${url}/topic/${response.id}`, exact: false, dynamic: true, id: response.id
            });
        }
    }, [])

    const onUpdateTitleTopic = useCallback(async ({topicId, title}) => {
        await dispatch(updateTopic({
            topicId,
            title: title,
        }));
        dispatch({
            type: ACTIONS.SET_TITLE_TOPIC,
            title,
        });
    }, []);

    return {
        menus,
        menuHelper,
        fetchCategoryTopics,
        onCreateTopic,
        onUpdateTitleTopic,
        onCreateExistTopic,
    }
}
